export default __webpack_public_path__ + "static/media/HistoryIcon.b62dead1.svg";